module.exports = __webpack_public_path__ + "b2ad31bb9a2e6dd2020366bf4462d563.png";